import { CustomTag } from "../../../Tags";
import { TagColors } from "../../../Tags/utils/theme";

/**
 * 주문상태 enum
 * @notice 전체
 * -- 세차권 및 반품 추가
 */
export enum ReturnStatus {
  /**
   * @notice 세차권
   */
  /**
   * 발급취소
   */
  CANCELED_ISSUE = "발급취소",

  /**
   * @notice 반품요청
   */
  /**
   * 반품요청
   */
  REQUESTED_RETURN = "반품요청",
  /**
   * 반품승인
   */
  CONFIRMED_RETURN = "반품승인",
  /**
   * 회수신청
   */
  APPLIED_RETURN = "회수준비중",
  /**
   * 회수완료
   */
  COMPLETED_DELIVERY_RETURN = "회수완료",
  /**
   * 반품완료
   */
  COMPLETED_RETURN = "반품완료",

  /**
   * @notice 배터리 상태
   */

  /**
   * 예약취소
   * 출동 후
   */
  CANCELLATION_AFTER_DISPATCH = "출동후취소",
  /**
   * 예약취소
   * 출동 전
   */
  CANCELLATION_BEFORE_DISPATCH = "출동전취소",
  /**
   * 예약취소
   * 자체취소
   */
  CANCELLATION_SELF_ORDER = "자체취소",
}

/**
 * 주문상태 key type
 */
export type ReturnStatusType = keyof typeof ReturnStatus;

/**
 * 주문상태별 컬러
 */
export const returnStatusTypeColor: {
  [key: string]: TagColors;
} = {
  REQUESTED_RETURN: "red",
  CONFIRMED_RETURN: "primary",
  APPLIED_RETURN: "primary",
  COMPLETED_RETURN: "black",

  CANCELLATION_AFTER_DISPATCH: "black",
  CANCELLATION_BEFORE_DISPATCH: "black",
  CANCELLATION_SELF_ORDER: "black",

  CANCELED_ISSUE: "black",
};

interface ReturnStatusTagProps {
  value: ReturnStatusType;
}

/**
 * 반품 및 취소 상태 태그
 * @param value
 * @returns
 */
export const ReturnStatusTag: React.FC<ReturnStatusTagProps> = ({ value }) => {
  return (
    <>
      {ReturnStatus[value] ? (
        <CustomTag colors={returnStatusTypeColor[value] as TagColors}>
          {ReturnStatus[value]}
        </CustomTag>
      ) : (
        "-"
      )}
    </>
  );
};
